module.exports = __webpack_public_path__ + "img/title2.711eca76.jpg";